module.exports = __webpack_public_path__ + "static/media/gten.f4e9ba2a.png";